<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <p class="text-center py-5">（請將怪盜的名片，出示予館員或志工，館員或志工將會交予您怪盜留下的最終謎題。）</p>

              <npc :npc-id="1" right>呂善安！這是⋯⋯</npc>
              <npc :npc-id="0">嗯，恐怕是最後的謎題吧！我們離終點很近了。</npc>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part>
              <p>請打開名片交換到的謎題，在此填入正確答案，答案是四個字。</p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage8_5',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第八章 - 5',
      isQuestion: true,
      stageId: 'yesmace',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
